import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {ProgressService} from '../../services/progress.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'MaxStorage';
    loading = false;

    constructor(public userService: UserService,
                private progressService: ProgressService,
                private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.progressService.isLoading().subscribe((value: boolean) => {
            this.loading = value;

            // Fix of problem
            // @see https://github.com/angular/angular/issues/17572
            this.cdr.detectChanges();
        });
    }
}



// WEBPACK FOOTER //
// /app/src/AppModule/AppComponent/app.component.ts